import React from "react";
import { Link } from 'react-router'
import { useAuth } from '../context/AuthContext';

export default function Header() {
  const { isAuthenticated, setIsAuthenticated } = useAuth();
  const handelLogout = () => {
    localStorage.removeItem("token");
    window.location.href = "/";
    setIsAuthenticated(false);
    sessionStorage.removeItem('userData');
  };

  return (
    <>
      <nav className="navbar navbar-expand bg-secondary navbar-dark sticky-top px-4 py-0">
        <Link to="/" className="navbar-brand d-flex d-lg-none me-4">
          <h2 className="text-primary mb-0">
            <i className="fa fa-user-edit" />
          </h2>
        </Link>
        
        
        <div className="navbar-nav align-items-center ms-auto">
          
          
          <div className="nav-item dropdown">
            <Link
              href="#"
              className="nav-link dropdown-toggle"
              data-bs-toggle="dropdown"
            >
              <img
                className="rounded-circle me-lg-2"
                src="assets/img/user.jpg"
                alt = "Home"
                style={{ width: 40, height: 40 }}
              />
              <span className="d-none d-lg-inline-flex">John Doe</span>
            </Link>
            <div className="dropdown-menu dropdown-menu-end bg-secondary border-0 rounded-0 rounded-bottom m-0">
              <Link to="/" className="dropdown-item">
                My Profile
              </Link>
              <Link href="#" className="dropdown-item">
                Settings
              </Link>
              <button onClick={handelLogout} className="dropdown-item">
                Log Out
              </button>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}
